import { Component, OnInit , Input } from '@angular/core';
import { SettingsService } from 'src/app/Api_Module/api/settings.service';
import { MantainCommand } from 'src/app/Api_Module/model/mantainSetting';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss']
})
export class SettingsModalComponent implements OnInit {
  loading: boolean;
  alert: any;
  updateMode: boolean;
  @Input() setting: MantainCommand;
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  constructor(private modalService: NgbModal, private settingService: SettingsService, private toastr: ToastrService) { }

  ngOnInit() {
  }
  openLg(content) {
    if (!!this.setting && !!this.setting['id'] && this.setting['id'] > 0) {
      this.updateMode = true;
    } else {
      this.setting = { name: '', value: '' };
      this.updateMode = false;
    }
    this.setting.endDate = new Date(this.setting.endDate);
    this.setting.startDate = new Date(this.setting.startDate);
    console.log(this.setting);
    this.modalService.open(content, { size: 'lg' });
  }

  save() {
    this.settingService.save(this.setting as MantainCommand).subscribe((resp : boolean) => {
      this.loading = false;
      this.toastr.success('Setting created');

      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }
}
